var _style, _defs, _path, _path2, _path3, _circle, _path4, _path5, _path6, _use, _use2, _use3, _rect, _rect2, _path7, _g, _g2, _path8, _g3, _path9, _g4, _path10, _path11, _rect3, _g5, _path12, _g6, _rect4, _g7, _path13, _g8, _rect5, _g9, _path14, _g10, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlider2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 530,
    height: 400,
    viewBox: "0 0 530 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".B{fill-rule:nonzero}.C{fill:#fff}.D{fill:#b4bed5}.E{fill:#e5e9f1}.F{opacity:.53}.G{stroke:#f4674c}.H{stroke-width:.5}.I{stroke-width:1.5}>")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "97.9359263%",
    y1: "49.9947529%",
    x2: "-51.0404411%",
    y2: "49.9947529%",
    id: "A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5fbff",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4f9ff",
    stopOpacity: 0.07,
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b6f3ff",
    stopOpacity: 0.26,
    offset: "31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6de9ff",
    stopOpacity: 0.56,
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09dcff",
    stopOpacity: 0.96,
    offset: "97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00dbff",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.5369097%",
    y1: "-34.1478408%",
    x2: "57.6262347%",
    y2: "50.6480201%",
    id: "B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbc00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "126.410845%",
    y1: "49.8870539%",
    x2: "14.3358309%",
    y2: "50.0604661%",
    id: "C"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5fbff",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32cb82",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "70.3301261%",
    y1: "50.0541806%",
    x2: "-35.3931652%",
    y2: "49.7724413%",
    id: "D"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5fbff",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32cb82",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "38.6983614%",
    y1: "38.1074787%",
    x2: "12.0655435%",
    y2: "-0.878624529%",
    id: "E"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5fbff",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32cb82",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "89.5181417%",
    y1: "49.981982%",
    x2: "-34.0660395%",
    y2: "49.981982%",
    id: "F"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5fbff",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4f9ff",
    stopOpacity: 0.07,
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b6f3ff",
    stopOpacity: 0.26,
    offset: "31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6de9ff",
    stopOpacity: 0.56,
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09dcff",
    stopOpacity: 0.96,
    offset: "97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00dbff",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "71.6740257%",
    y1: "49.981982%",
    x2: "-32.3862546%",
    y2: "49.981982%",
    id: "G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5fbff",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4f9ff",
    stopOpacity: 0.07,
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b6f3ff",
    stopOpacity: 0.26,
    offset: "31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6de9ff",
    stopOpacity: 0.56,
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09dcff",
    stopOpacity: 0.96,
    offset: "97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00dbff",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "116.279516%",
    y1: "49.981982%",
    x2: "-139.834901%",
    y2: "49.981982%",
    id: "H"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5fbff",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4f9ff",
    stopOpacity: 0.07,
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b6f3ff",
    stopOpacity: 0.26,
    offset: "31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6de9ff",
    stopOpacity: 0.56,
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09dcff",
    stopOpacity: 0.96,
    offset: "97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00dbff",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9960732%",
    y1: "106.363636%",
    x2: "49.9960732%",
    y2: "-6.70454545%",
    id: "I"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09f",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09f",
    offset: "32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#903a5e",
    offset: "49%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e50200",
    offset: "58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e50200",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9018299%",
    y1: "106.242197%",
    x2: "49.9018299%",
    y2: "-7.36579276%",
    id: "J"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09f",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09f",
    offset: "32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#903a5e",
    offset: "49%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e50200",
    offset: "58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e50200",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9960732%",
    y1: "105.101143%",
    x2: "49.9960732%",
    y2: "-5.10114336%",
    id: "K"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09f",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09f",
    offset: "32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#903a5e",
    offset: "49%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e50200",
    offset: "58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e50200",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "L",
    d: "M262.64 98.64h104.18v27.75H262.64z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M306.25 400.34h159.38l-14.34-25.22h78.06v-70.07h-126.2l14.3 25.45H231.88z",
    opacity: 0.4,
    fill: "url(#A)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M272.03 246.35h136.65l.12 10.9H272.15zm155 0h102.68v10.9H427.16zm-199.86 0h27.6l.12 10.9h-27.6zm47.75-28h206l.13 10.9h-206zm-70.08 0h53.94l.13 10.9h-53.95zm-9.1 55.54h285.12l.12 10.9H195.88z",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light"
    },
    className: "C"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.46 130.7H24.54c-8.176.01-14.803 6.634-14.82 14.8v109.62a14.77 14.77 0 0 0 3.64 9.71h-.12l.6.5A14 14 0 0 0 15.7 267l66.7 58.92V270h80c8.183-.006 14.814-6.637 14.82-14.82V145.52c-.01-8.155-6.605-14.772-14.76-14.8z",
    fill: "url(#B)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M277.26 77.56H420.3l-9.16-16.1h97V16.74H380.42L389.54 33H277.26z",
    opacity: 0.8,
    fill: "url(#C)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#32cb82",
    cx: 507.32,
    cy: 39.08,
    r: 22.39
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M520.54 31.88L517.6 29a1.06 1.06 0 0 0-1.46 0L503.6 42l-5.43-5.35a1 1 0 0 0-1.45 0l-2.6 2.57a1 1 0 0 0 0 1.43l8.68 8.6a1.45 1.45 0 0 0 1.71 0l16-15.86a1.06 1.06 0 0 0 .04-1.52z",
    className: "C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    opacity: 0.54,
    d: "M277.26 55.14h120.56v22.5H277.26z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M293.23 73.73v-42C293.208 14.42 279.18.392 261.87.37H107.94C90.63.392 76.602 14.42 76.58 31.73v163h216.65v-121z",
    opacity: 0.8,
    fill: "url(#E)"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    fill: "url(#F)",
    opacity: 0.3
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    y: 41.11,
    fill: "url(#G)",
    opacity: 0.3
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    y: 78.66,
    fill: "url(#H)",
    opacity: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#cdd4e2",
    x: 82.4,
    y: 6.16,
    width: 205.01,
    height: 394.17,
    rx: 26.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 92.55,
    y: 16.71,
    width: 184.71,
    height: 371.77,
    rx: 18.32,
    className: "C"
  })), /*#__PURE__*/React.createElement("g", {
    className: "D"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.62,
    y: 29.24,
    width: 54.53,
    height: 6.21,
    rx: 3.105,
    style: {
      mixBlendMode: "multiply"
    },
    className: "F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.4,
    y: 29.24,
    width: 33.24,
    height: 6.21,
    rx: 3.105,
    style: {
      mixBlendMode: "multiply"
    },
    className: "F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M209.38 382.07h-47.06a2.09 2.09 0 0 1-1.93-3.171 2.09 2.09 0 0 1 1.93-.999h47.06a2.09 2.09 0 0 1 0 4.17",
    fill: "#d7dde9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "E"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.62,
    y: 116.34,
    width: 157.35,
    height: 93.46,
    rx: 6.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.62,
    y: 221.89,
    width: 157.35,
    height: 45.98,
    rx: 6.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.62,
    y: 279.95,
    width: 157.35,
    height: 45.98,
    rx: 6.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.62,
    y: 343.83,
    width: 157.35,
    height: 20.36,
    rx: 10.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.34,
    y: 54.01,
    width: 72.63,
    height: 50.25,
    rx: 6.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.62,
    y: 54.01,
    width: 72.63,
    height: 50.25,
    rx: 6.05
  })))), /*#__PURE__*/React.createElement("image", {
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply"
    },
    y: 121,
    width: 187,
    height: 159,
    xlinkHref: "data:image/png;base64,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"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.55,
    y: 136.53,
    width: 155.9,
    height: 127.6,
    rx: 9.26,
    className: "C"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd3db",
    opacity: 0.3,
    d: "M15.55 163.25h155.9v25.07H15.55z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.55 163.25h155.9M15.55 188.3h155.9m-155.9 25.08h155.9m-155.9 25.07h155.9",
    opacity: 0.7,
    stroke: "#e5e9f0",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "E"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.72,
    cy: 200.55,
    r: 4.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.22 198.6h103.65v3.88H44.22z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M41.67 148.48h103.65v3.88H41.67z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "D F"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.22 173.84h62.4v3.88h-62.4z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.63 248.66h46.62v3.88H67.63z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "D F"
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "E"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.72,
    cy: 226.06,
    r: 4.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.22 224.54h56.94v3.88H44.22z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.07 170.3H30a2.66 2.66 0 0 0-2.67 2.66h6.4a2.67 2.67 0 0 0-2.67-2.66zm6 5.25v-1.3h-4.6a1.25 1.25 0 0 0-1.26 1.25v6.36h.53A3.56 3.56 0 0 0 34 181l1.25 1.25.92-.92L34.8 180a3.66 3.66 0 0 0 .43-1.55H37v-1.25h-1.8v-1.66h1.87zm-8.4-1.3H24v1.3h1.8v1.66H24v1.3h1.8a3.53 3.53 0 0 0 .44 1.55l-1.35 1.33.92.92 1.26-1.25a3.54 3.54 0 0 0 2.25.81h.52v-6.36a1.25 1.25 0 0 0-1.22-1.25h.03z",
    fill: "#09f"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M249.24 155.74a30.09 30.09 0 0 1-6.53 19.1 26.73 26.73 0 0 1-16.53 9.75 26 26 0 0 1-19.18-4.42 27.63 27.63 0 0 1-7.36-7.6 28.72 28.72 0 0 1-4.11-10.18 26.81 26.81 0 0 1 4.12-20.06 28.15 28.15 0 0 1 16.64-11.64 30.71 30.71 0 0 1 20.22 2.16 35.77 35.77 0 0 1 8.92 5.94 37.52 37.52 0 0 1 7.17 8.74",
    stroke: "#09f",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.4 223.8a24.42 24.42 0 0 0-20.34 7.55l6.47 14.12 13.87-14.32v-7.35z",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    },
    className: "E"
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 330.66,
    y: 98.62,
    width: 198.68,
    height: 27.76,
    rx: 3.69,
    className: "C"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "D"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 343.15,
    cy: 112.5,
    r: 4.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.78 110.56h26.63v3.88h-26.63z"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#I)",
    d: "M394.8 112.47h20.7l8.87-6.23 15.1 8.8 12.64-5.56 9.53 3h60.5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.4 110.2a3.89 3.89 0 0 1-2.761-6.641 3.89 3.89 0 0 1 6.641 2.761 3.89 3.89 0 0 1-3.88 3.88z",
    className: "H"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.41,
    cy: 106.32,
    r: 2.15,
    className: "B C I"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 330.66,
    y: 177.31,
    width: 198.68,
    height: 27.76,
    rx: 3.69,
    className: "B C"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "D B"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 343.15,
    cy: 191.19,
    r: 4.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.78 189.25h21.28v3.88h-21.28z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#J)",
    d: "M394.8 191.2l7.7-4.13 8.64 4.13h4.34l8.87-4.2 15.1 4.2h12.64l9.53-8 16.96 8h43.54"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.4 191a3.89 3.89 0 0 1-2.764-6.637 3.89 3.89 0 0 1 6.644 2.747 3.9 3.9 0 0 1-3.88 3.89z",
    className: "H"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.41,
    cy: 187.07,
    r: 2.15,
    className: "B C I"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 330.66,
    y: 139.74,
    width: 198.68,
    height: 27.76,
    rx: 3.69,
    className: "B C"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "D B"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 343.15,
    cy: 153.62,
    r: 4.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.78 151.68h31.87v3.88h-31.87z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#K)",
    d: "M394.8 154.13h20.7l8.87 3.87 15.1-11.37 12.64 6.03 9.53 4.2 6.67-4.24 7.8 3.65 4.52-3.65 4.75-3.85 6.1 5.35h30.67"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.4 152.67a3.89 3.89 0 0 1-2.764-6.637 3.89 3.89 0 0 1 6.644 2.747 3.89 3.89 0 0 1-3.88 3.89z",
    className: "H"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 485.39,
    cy: 148.78,
    r: 2.15,
    className: "B C I"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M293.23 319.65c-2.94.47-48.33-6.75-50.84-9.33l-30-42.22c-4.88-5.82-11.82-5.15-16.37-1.43-2.3 1.87-4 5.5-4.48 8.47a12.05 12.05 0 0 0 2.51 9.32l36.56 60.16a92.68 92.68 0 0 0 22.19 23.07l20.3 14.4 20.12-62.44zm-49.5-12.95h2.9c3.08-1.7 1.68-5.3.73-8.7l-21.8-88.67 35.6 101.45-17.45-4.08z",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    },
    className: "E B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.82 254.06l-.8-2.5.5 1.53z",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    },
    fill: "#1c1c1b",
    className: "B"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M376 339.33l11.08 34.96-11.05-34.97 2.67-11.37zm-9.8-87.93l.8 2.6 13.2 40.52-16.76-52.44a11.19 11.19 0 0 0-.91-2.24l3.35 10.6a7.61 7.61 0 0 1 .33.95z",
    fill: "#3c3c3a",
    className: "B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M367 254l-.83-2.6-3.65-11.54c-2.7-5.07-9.18-8.54-17.54-7.7-5.72.58-10.6 3-13.45 6.18-3.06-3.88-9.46-6.17-16.57-5.45-5.58.57-10.35 2.85-13.23 5.94-3-4-9.5-6.3-16.7-5.6h-.25c-6.24.7-11.45 3.54-14.07 7.25l-33.24-76.67c-5.15-11.6-22.32-7-23.88 3.84a12 12 0 0 0 .51 5.43l41.5 131.44a7.54 7.54 0 0 1-4.59 2.7c-2.93.47-6.13-.9-8.64-3.47l-30.05-35.57c-4.88-5.82-11.82-5.15-16.37-1.43a12.38 12.38 0 0 0-4.48 7.5 12 12 0 0 0 2.51 9.31l36.65 54.5a92.51 92.51 0 0 0 22.19 23.07l16.32 11.93a44.49 44.49 0 0 0 41 27.24h84.95l-19.12-61 2.7-11.3 2.6-11c0-.26.1-.5.14-.77s.08-.4.1-.6a45.57 45.57 0 0 0 .69-6.87v-2.3a2.44 2.44 0 0 1 0-.27 43.47 43.47 0 0 0-1.19-8.55.94.94 0 0 0 0-.16 24.19 24.19 0 0 0-.26-1l-.18-.64c0-.15-.1-.3-.13-.44L367 254z",
    fill: "#badffc",
    className: "B"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#90c8f3",
    className: "B"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M352.86 400.34h42.26l-19.12-61 2.7-11.34 2.4-10.18.28-1.3c0-.12.05-.24.07-.36l.1-.6a45.57 45.57 0 0 0 .69-6.87v-2.3a2.44 2.44 0 0 1 0-.27 43.47 43.47 0 0 0-1.19-8.55.94.94 0 0 0 0-.16l-.26-1-.18-.64c0-.15-.1-.3-.13-.44l-14.3-43.94-3.65-11.54c-2.7-5.07-9.18-8.54-17.54-7.7-5.72.58-10.6 3-13.45 6.18-3.06-3.88-9.46-6.17-16.57-5.45-5.58.57-10.35 2.85-13.23 5.94l51.13 161.5z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.08 326.07l5.83 1.57-7.3-23.07a7.54 7.54 0 0 1-4.59 2.7c-2.93.47-6.13-.9-8.64-3.47l-30.05-35.57c-4.88-5.82-11.82-5.15-16.37-1.43l33.17 41.1a53.87 53.87 0 0 0 27.94 18.18z",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M271 241.08l-33.52-77.25c-2.9-6.52-9.6-7.9-15.2-5.9L249.2 228a20.37 20.37 0 0 0 19.31 13.08h2.5z",
    opacity: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider2);
export default __webpack_public_path__ + "static/media/slider-2.d4ba4f9ae0c4c3b770ab40aafb627895.svg";
export { ForwardRef as ReactComponent };